import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { AppBar } from '../components';
import ThemeColors from '../theme/colors';
import ThemeImages from '../theme/images';

const StyledButton = withStyles({
  root: {
    background: 'none',
    color: '#000',
    height: 64,
    borderRadius: 0,
    '&:hover': {
      background: 'none',
      borderRadius: 0,
      fontWeight: 'bold',
      borderTop: `2px solid ${ThemeColors.primary1Color}`,
    },
  },
})(Button);


class Navbar extends Component {

  state = {
    width: 0,
  }

  componentDidMount() {
    this.updateCurrendWidth();
    window.addEventListener('resize', this.updateCurrendWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateCurrendWidth);
  }

  updateCurrendWidth = () => {
    this.setState({ width: window.innerWidth });
  }

  handleNavigateToRoute = route => {
    this.props.history.push(route);
  }

  renderNavButtons() {
    /* eslint-disable */
    if (this.props.loggedIn) {
      return (<StyledButton
        onClick={() => window.location = '/courses'}
      >
        Zur App
        </StyledButton>);
    }

    return (
      <div>
        <StyledButton
          onClick={() => this.handleNavigateToRoute('signup')}
        >
          registrieren
        </StyledButton>
        <StyledButton
          onClick={() => this.handleNavigateToRoute('login')}
        >
          login
          </StyledButton>
      </div>
    );
        /* eslint-enable */
  }
  render() {
    const { classes } = this.props;

    const toolbarStyle = {
      textAlign: 'center',
      background: 'none',
      height: 64,
      alignItems: 'flex-start',
      display: 'flex',
    };

    const logo = this.state.width > 450
    ? (
      <img
        alt="Logo"
        src={ThemeImages.logoPath}
        className={`verticalAlign ${classes.logoStyle}`}
      />
    )
    : null;


    return (
      <AppBar
        toolBarStyle={toolbarStyle}
        style={{ background: 'none', height: 80 }}
        elevation={0}
        showMenuIconButton={false}
      >
        <div className="container">
          <div
            className={`col-xs-12 col-lg-10 col-md-10 ${classes.navBarInnerContainer}`}
          >
            {logo}
            {this.renderNavButtons()}
          </div>
        </div>
      </AppBar>
    );
  }
}

const styles = () => ({
  navBarInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  logoStyle: {
    maxHeight: 64,
    width: 'auto',
    padding: 10,
  },
});

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  loggedIn: PropTypes.bool,
};

Navbar.defaultProps = {
  loggedIn: false,
};

export default withStyles(styles)(Navbar);



// WEBPACK FOOTER //
// ./src/app/navbar_new/navbar.js